import { HttpInterceptors } from "./http.interceptor";

export class TransactionService extends HttpInterceptors {
	async listTransactions (filters) {
		const response = await this.axios.get("transaction/listTransactions", { params: { filters } });
		return response.data;
	}

	async createTransaction (payload) {
		const response = await this.axios.post("transaction/createTransaction", payload);
		return response.data;
	}

	async updateTransaction (payload) {
		const response = await this.axios.patch("transaction/updateTransaction", payload);
		return response.data;
	}

	async deleteTransaction (payload) {
		const response = await this.axios.patch("transaction/deleteTransaction", payload);
		return response.data;
	}

	async getTransactionsByParams (filters) {
		const response = await this.axios.get("transaction/getTransactionsByParams", { params: { filters } });
		return response.data;
	}
}
